import { number, route } from 'react-router-typesafe-routes/dom';

import { terminalsAppRoute } from 'app/router/routes';

const employeesRoute = route(
  'employees',
  {},
  {
    ADD: route('add'),
  }
);
const employeeRoute = route('employee/:id', {
  params: { id: number() },
});

const profilesRoute = route(
  'profiles',
  {},
  {
    ADD: route('add'),
  }
);

const profileRoute = route('profile/:id', {
  params: { id: number() },
});

const terminalsRoute = route(
  'devices',
  {},
  {
    ADD: route('add'),
  }
);

const terminalRoute = route('device/:id', {
  params: { id: number() },
});

export const appRoute = route(
  terminalsAppRoute.relativePath,
  {},
  {
    EMPLOYEES: employeesRoute,
    EMPLOYEE: employeeRoute,

    PROFILES: profilesRoute,
    PROFILE: profileRoute,

    TERMINALS: terminalsRoute,
    TERMINAL: terminalRoute,
  }
);
